import Annotation from 'components/Annotation'
import AreaAnnotation from 'components/AreaAnnotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'
const isMobile = window.innerWidth < 712

export const lausanne_data: CityData = {
  name: 'Lausanne-centre',
  bfsid: '5586',
  sat_images: [
    {
      label: 'Moins aisés - Sébeillon/Malley',
      image: isMobile
        ? require('../../../Content/Maps/maps_5586_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_5586_sat_poor.jpg'),
    },
    {
      label: 'Plus aisés - Mousquines/Bellevue',
      image: isMobile
        ? require('../../../Content/Maps/maps_5586_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_5586_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'be_1',
      text: (
        <>
          <p>
            La ville est scindée en deux, avec une population aisée à l'est et à
            l'ouest, plus dense, des couches de population plus pauvres. Le
            centre-ville reste malgré tout plutôt mixte.
          </p>
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Mousquines/Bellevue</Annotation>,
          position: { x: 77, y: 67 },
          position_mobile: { x: 58, y: 73 },
        },
        {
          content: <Annotation priority={3}>Chailly/Rovéréaz</Annotation>,
          position: { x: 87, y: 57 },
          // position_mobile: { x: 50, y: 38 },
        },
        {
          content: <Annotation priority={3}>Sauvabelin</Annotation>,
          position: { x: 58, y: 33 },
          position_mobile: { x: 57, y: 36 },
        },
        {
          content: <Annotation priority={3}>Sébeillon/Malley</Annotation>,
          position: { x: 13, y: 45 },
          position_mobile: { x: 4, y: 40 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_5586_all_mob.jpg')
        : require('../../../Content/Maps/maps_5586_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_5586_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_5586_all_dm.jpg'),
    },
    {
      id: 'be_2',
      text: (
        <>
          <p>
            Le quartier résidentiel des <TM prio={2}>Mousquines/Bellevue</TM>{' '}
            est un quartier historique habité par des riches. On y trouve villas
            et maisons de maître avec beaucoup de terrain et d'espaces verts. Le
            palais du Tribunal fédéral y surplombe le grand parc de Mon-Repos.
          </p>
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Chailly/Rovéréaz</Annotation>,
          position: { x: 87, y: 57 },
          // position_mobile: { x: 50, y: 38 },
        },
        {
          content: <Annotation priority={3}>Sauvabelin</Annotation>,
          position: { x: 58, y: 33 },
          position_mobile: { x: 57, y: 36 },
        },
        {
          content: <Annotation priority={3}>Sébeillon/Malley</Annotation>,
          position: { x: 13, y: 45 },
          position_mobile: { x: 4, y: 40 },
        },

        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 80}
              angle={isMobile ? 269 : 35}
            >
              Mousquines/
            </CircleAnnotation>
          ),
          position: { x: 75, y: 65 },
          position_mobile: { x: 74, y: 63 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 80}
              angle={isMobile ? 230 : 55}
            >
              Bellevue
            </CircleAnnotation>
          ),
          position: { x: 75, y: 65 },
          position_mobile: { x: 74, y: 63 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_5586_rich_mob.jpg')
        : require('../../../Content/Maps/maps_5586_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_5586_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_5586_rich_dm.jpg'),
    },
    {
      id: 'be_3',
      text: (
        <>
          <p>
            Les habitants pauvres vivent notamment dans le quartier de{' '}
            <TM prio={3}>Sébeillon/Malley.</TM> En pleine mutation, cette zone
            d'héritage industriel s'étend le long de trois grands axes routiers
            et de la ligne de chemin de fer.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 40 : 100}
              angle={isMobile ? 270 : 255}
            >
              Sébeillon/Malley
            </CircleAnnotation>
          ),
          position: { x: 28, y: 45 },
          position_mobile: { x: 30, y: 46 },
        },
        {
          content: <Annotation priority={3}>Mousquines/Bellevue</Annotation>,
          position: { x: 77, y: 67 },
          position_mobile: { x: 58, y: 73 },
        },
        {
          content: <Annotation priority={3}>Chailly/Rovéréaz</Annotation>,
          position: { x: 87, y: 57 },
          // position_mobile: { x: 50, y: 38 },
        },
        {
          content: <Annotation priority={3}>Sauvabelin</Annotation>,
          position: { x: 58, y: 33 },
          position_mobile: { x: 57, y: 36 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_5586_poor_mob.jpg')
        : require('../../../Content/Maps/maps_5586_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_5586_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_5586_poor_dm.jpg'),
    },
  ],
}
